import React, { useEffect, useState } from 'react';
import { post } from './AuthToken';
import { useSelector } from 'react-redux';
import setUiMessage from '../../Utilities/Tostify';
import { FaEye } from 'react-icons/fa';
import { MdEdit } from 'react-icons/md';
import { ImCross } from 'react-icons/im';

function ViewOnlineProfile({
  profileData,
  onClose,
  openOnlineEditProfile,
  setProfileData,
}) {
  const { user } = useSelector((store) => store.auth);
  const [onlineProfileData, setOnlineProfileData] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const response = await post('api/auth/getOnlineProfile', {
          userId: user?.id,
        });
        if (response.status === 200) {
          //   console.log(response.data);
          setOnlineProfileData(response?.data);
          setProfileData(response?.data);
        }
      } catch (error) {
        setUiMessage('err', error.message);
      }
    })();
  }, [setProfileData, user?.id]);

  const {
    providerName,
    enableOnlineProfile,
    enableOpenSchedule,
    userProfilePic,
    aboutMe,
    selectedClinicServicesList = [],
    selectedClinicLocationsList = [],
    selectedClinicInsuranceList = [],
    // tov_new,
    // tov_followup,
    // default_app_duration,
    previewProfileUrl,
    tov_followup_name,
    tov_new_name,
  } = onlineProfileData || {};

  const profileEnabled =
    enableOnlineProfile === 1 ||
    enableOnlineProfile === '1' ||
    enableOnlineProfile === true;

  const scheduleEnabled =
    enableOpenSchedule === 1 ||
    enableOpenSchedule === '1' ||
    enableOpenSchedule === true;

  const handleEditProfile = () => {
    // TODO
    openOnlineEditProfile();
    onClose();
  };

  const uniqueInsurance = [
    ...new Map(
      selectedClinicInsuranceList.map((item) => [
        item.insurance_company_name,
        item,
      ]),
    ).values(),
  ];

  const handleClose = () => {
    onClose();
    setProfileData(null);
  };

  return (
    <div className="modalBackground">
      <div
        className="popup__content lg scrollbar"
        style={{ transform: 'scale(1)' }}
      >
        <div className="popup-header flex justify-between">
          <h2 className="fw-500 mb-3">My Online Profile</h2>

          <span className="close-btn" onClick={handleClose}>
            {/* &times; */}
            <ImCross />
          </span>
        </div>

        <div className="popup-body">
          <div className="onlinePresence">
            <div className="flex justify-between items-center mb-4">
              <div>
                <h2 className="fs-lg fw-600 mb-4">
                  My Online Profile - {providerName}
                </h2>
              </div>

              <div className="flex gap-2">
                <button
                  className="btn-black rounded-md flex items-center"
                  onClick={handleEditProfile}
                >
                  <MdEdit /> Edit Profile
                </button>

                <a
                  href={previewProfileUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="border border-lightgray bg-white rounded-md flex items-center gap-2 px-2 py-2 cursor-pointer">
                    {/* <img src="./images/eye.svg" width="14" alt="Preview" /> */}
                    <FaEye />
                    Preview Profile
                  </button>
                </a>
              </div>
            </div>

            {/* Profile Status */}

            <div className="onlinePresence__card bg-white mb-4">
              <h3 className="text-black mb-4 fs-sm fw-600">Profile Status</h3>

              <div className="flex items-center gap-3 pt-3">
                <div className="text-black fs-sm">Online Profile</div>

                {profileEnabled ? (
                  <span className="badge-success py-1 fw-600">Enabled</span>
                ) : (
                  <span className="badge-lightgray py-1 fw-600">Disabled</span>
                )}
              </div>
            </div>

            {/* Online Appointment */}

            <div className="onlinePresence__card bg-white mb-4">
              <h3 className="text-black mb-4 fs-sm fw-600">
                Online Appointment
              </h3>

              <div className="flex items-center justify-between gap-3 pt-3">
                <div className="flex flex-col">
                  <div className="text-black fs-sm mb-1">
                    Open schedule for online appointments
                  </div>

                  <p className="text-gray fs-xs leading-normal">
                    {scheduleEnabled
                      ? 'Online booking is enabled.'
                      : 'Online booking is disabled.'}
                  </p>
                </div>

                {scheduleEnabled ? (
                  <span className="badge-success py-1 fw-500">Enabled</span>
                ) : (
                  <span className="badge-lightgray py-1 fw-500">Disabled</span>
                )}
              </div>
            </div>

            {/* Profile Picture */}

            <div className="onlinePresence__card bg-white mb-4">
              <h3 className="text-dark mb-4 fs-sm fw-600">
                Profile Picture & About
              </h3>

              <div className="flex flex-col gap-8">
                <div className="onlinePresence__card-profile">
                  <div className="text-black fs-sm">Profile Picture</div>

                  <div className="onlinePresence__card-avatar overflow-hidden rounded-full">
                    <img
                      src={userProfilePic || '/images/default-profile.png'}
                      alt="Profile"
                    />
                  </div>
                </div>

                <div className="onlinePresence__card-about">
                  <div className="fs-sm text-dark">About Me</div>

                  <p className="text-dark fs-sm leading-normal content-line-break">
                    {aboutMe || 'No description available.'}
                  </p>
                </div>
              </div>
            </div>

            {/* Default Visit Type */}

            <div className="onlinePresence__card bg-white mb-4">
              <h3 className="text-black mb-4 fs-sm fw-600">
                Default type of Visit
              </h3>

              <div className="flex items-center gap-3 pt-3">
                <div className="text-black fs-sm">New pt default:</div>

                <span className="badge-success py-1 fw-600">
                  {tov_new_name}
                </span>

                <div
                  className="text-black fs-sm"
                  style={{ marginLeft: '100px' }}
                >
                  Returning pt default:
                </div>

                <span className="badge-success py-1 fw-600">
                  {tov_followup_name}
                </span>

                {/*
              <div
                className="text-black fs-sm"
                style={{ marginLeft: "100px" }}
              >
                Default app duration:
              </div>

              <span className="badge-success py-1 fw-600">
                {default_app_duration} min
              </span>
              */}
              </div>
            </div>
            {/* Services Offered */}

            <div className="onlinePresence__card bg-white mb-4">
              <h3 className="text-black mb-4 fs-sm fw-600">Services Offered</h3>

              <div className="onlinePresence__card-tags flex gap-2 flex-wrap">
                {selectedClinicServicesList.length > 0 ? (
                  selectedClinicServicesList.map((service, index) => (
                    <span
                      key={service.id || service.service_id || index}
                      className="py-2 px-3 fs-11 fw-600 leading-normal bg-lightblue rounded-lg text-primary"
                    >
                      {service.service_name}
                    </span>
                  ))
                ) : (
                  <p className="text-gray fs-sm">No services available.</p>
                )}
              </div>
            </div>

            {/* Practice Locations */}

            <div className="onlinePresence__card bg-white mb-4">
              <h3 className="text-black mb-4 fs-sm fw-600">
                Practice Locations
              </h3>

              <div className="flex flex-col gap-4">
                {selectedClinicLocationsList.length > 0 ? (
                  selectedClinicLocationsList.map((location, index) => (
                    <div
                      key={location.id || location.location_id || index}
                      className="onlinePresence__card-location border border-lightgray rounded-lg p-4"
                    >
                      <h3 className="text-black mb-2 fs-sm">
                        {location.location_code}
                      </h3>

                      <p className="text-dark fs-xm">
                        {location.address_1} {location.city},{' '}
                        {location.stateCode} - {location.zip}
                      </p>
                    </div>
                  ))
                ) : (
                  <p className="text-gray fs-sm">No locations available.</p>
                )}
              </div>
            </div>

            {/* Accepted Insurance */}

            <div className="onlinePresence__card bg-white mb-4">
              <h3 className="text-black mb-4 fs-sm fw-600">
                Accepted Insurance
              </h3>

              <div className="onlinePresence__card-tags flex gap-2 flex-wrap">
                {uniqueInsurance.length > 0 ? (
                  uniqueInsurance.map((insurance, index) => (
                    <span
                      key={
                        insurance.id ||
                        insurance.insurance_company_id ||
                        insurance.insurance_company_name ||
                        index
                      }
                      className="py-2 px-3 fs-xs fw-600 bg-lightgreen rounded-lg text-success"
                    >
                      {insurance.insurance_company_name}
                    </span>
                  ))
                ) : (
                  <p className="text-gray fs-sm">
                    No insurance information available.
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewOnlineProfile;
